<pux-tabs class="h5" id="periods_tabs" :list="tabList" :status-hide-content="true" :id-for-active-tab="idForActiveTab" :change="$attrs.onChangeTab"></pux-tabs>